import React from 'react';
import Box from '@mui/material/Box';

import { useSalonPublicTheme } from '../../../context/SalonPublicThemeContext';


const asSxArray = (sx) => {
  if (!sx) return [];
  return Array.isArray(sx) ? sx : [sx];
};

const SalonPublicStyleScope = ({
  sectionKey,
  children,
  sx,
  ...props
}) => {
  const { layout } = useSalonPublicTheme();
  const section = layout.tokens.sectionStyles[sectionKey];
  const titleOverrides = section?.title?.styleOverrides || {};
  const contentOverrides = section?.content?.styleOverrides || {};

  return (
    <Box
      {...props}
      dir={layout.tokens.direction}
      data-salon-section={sectionKey}
      data-salon-title-customized={String(
        Object.keys(titleOverrides).length > 0
      )}
      data-salon-content-customized={String(
        Object.keys(contentOverrides).length > 0
      )}
      data-salon-title-style={JSON.stringify(titleOverrides)}
      data-salon-content-style={JSON.stringify(contentOverrides)}
      sx={[
        {
          '& [data-salon-text-role="title"]': titleOverrides,
          '& [data-salon-text-role="content"]': contentOverrides,
          '& [data-salon-text-role="content"] .MuiTypography-root': (
            contentOverrides
          ),
        },
        ...asSxArray(sx),
      ]}
    >
      {children}
    </Box>
  );
};

export default SalonPublicStyleScope;
